export const JUDGMENTS = {
  perfect: { label: 'PERFECT', kind: 'perfect' },
  good: { label: 'GOOD', kind: 'good' },
  miss: { label: 'MISS', kind: 'miss' },
  merge: { label: 'SYNC', kind: 'merge' },
  hold: { label: 'HOLD', kind: 'merge' },
  gold: { label: 'GOLD ×4', kind: 'perfect' },
  fever: { label: 'FEVER ×1.5', kind: 'perfect' },
  overdrive: { label: 'OVERDRIVE', kind: 'perfect' },
  double: { label: 'DOUBLE ×2', kind: 'perfect' },
  scrub: { label: 'SCRUB !', kind: 'merge' }
};

export const COPY = {
  hudHint: 'TAP · HOLD · DOUBLE · SCRUB (FROTTE !) · CLICK OU ESPACE',
  audioReady: 'AUDIO ON',
  audioMuted: 'MUTED'
};

export const DIFFICULTIES = [
  { id: 'easy', label: 'FACILE' },
  { id: 'normal', label: 'NORMAL' },
  { id: 'hard', label: 'DIFFICILE' }
];
